import React, { useState } from 'react';

import { get } from 'lodash';

import { Button, Input, Textarea, Dropdown } from '../../kaya';
import { authHelpers, generalHelpers } from '../../helpers';
import { userActions } from '../../actions';
import userStore from '../../zustand/user.store';
import logo from '../../assets/Logo.png';
import { generalConstants } from '../../constants';

import styles from './BusinessInfo.module.scss';

const BusinessInfo = () => {
  const { setUser, user, setAuthentication, userOffline } = userStore(
    (state) => ({
      setUser: state.setUser,
      user: state.user,
      defaultUser: state.defaultUser,
      setAuthentication: state.setAuthentication,
      authenticate: state.authenticate,
      userOffline: state.userOffline,
    })
  );
  const [formValues, setFormValues] = useState({
    businessName: '',
    city: '',
    country: '',
    address: '',
    description: '',
    occupation: '',
    other: '',
  });

  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState({
    businessName: '',
    city: '',
    country: '',
    address: '',
    description: '',
    occupation: '',
    other: '',
  });

  const handleChange = (id) => (value) => {
    if (typeof id !== 'object') {
      setFormValues({
        ...formValues,
        [id]: value,
      });
      setErr({
        ...err,
        [id]: '',
      });
    } else {
      setFormValues({
        ...formValues,
        ...id,
      });
      setErr({
        ...err,
        ...id,
      });
    }
  };

  const handleNextStep = async () => {
    const error = {
      businessName: authHelpers.validateBusinessName(
        formValues.businessName
      ),
      city: authHelpers.validateCity(formValues.city),
      country: authHelpers.validateCountry(
        get(formValues, 'country.value', '')
      ),
      address: authHelpers.validateAddress(formValues.address),
      description: authHelpers.validateDescription(
        formValues.description
      ),
      occupation: authHelpers.validateOccupation(
        get(formValues, 'occupation.value', '')
      ),
      other:
        formValues.occupation.value === 'OTHER'
          ? authHelpers.otherOption(formValues.other)
          : '',
    };

    if (!generalHelpers.isEmptyErrors(error)) {
      setErr({
        ...err,
        ...error,
      });
      return;
    }

    setLoading(true);

    const payload = {
      business_name: formValues.businessName,
      business_address: formValues.address,
      business_city: formValues.city,
      business_country: formValues.country.value,
      business_description: formValues.description,
      business_occupation:
        formValues.occupation.value === 'OTHER'
          ? formValues.other
          : formValues.occupation.value,
    };

    const data = await userActions.updateBusinessInfoAction(
      payload,
      user.id,
      userOffline
    );

    if (!data.success) {
      setLoading(false);
      return;
    }

    setUser({
      ...user,
      ...data.data,
    });
    setAuthentication({
      isAuthenticated: true,
      isPhoneVerified: true,
      isBusinessVerified: true,
      isPrimium: false,
    });

    setLoading(false);
  };

  return (
    <div className={styles.BusinessInfo}>
      <div className={styles.logo}>
        {/* <Icons type={ICONS.LOGO} /> */}
        <img src={logo} alt='' />
      </div>
      <div className={styles.boxLogin}>
        <div className={styles.box}>
          <p className={styles.title2}>Business Information</p>
          <form className={styles.form}>
            <Input
              className={styles.input1}
              id='businessName'
              placeholder='Business Name'
              value={formValues.businessName}
              onChange={handleChange('businessName')}
              errors={err}
              width='100%'
            />
            <Input
              width='100%'
              placeholder='Address'
              value={formValues.address}
              onChange={handleChange('address')}
              errors={err}
              id='address'
            />

            <Input
              width='100%'
              id='city'
              placeholder='City'
              value={formValues.city}
              onChange={handleChange('city')}
              errors={err}
            />
            <Dropdown
              width='100%'
              placeholder='Country'
              options={generalConstants.countries}
              value={formValues.country}
              errors={err}
              id='country'
              onMenuItemClick={handleChange('country')}
            />

            <Dropdown
              width='100%'
              placeholder='Occupation'
              options={generalConstants.occupations}
              value={formValues.occupation}
              errors={err}
              id='occupation'
              onMenuItemClick={handleChange('occupation')}
            />
            {formValues.occupation.value === 'OTHER' && (
              <Input
                width='100%'
                placeholder='Occupation'
                id='other'
                value={formValues.other}
                onChange={handleChange('other')}
                errors={err}
              />
            )}

            <Textarea
              className={styles.input3}
              placeHolder='Tell us about your business'
              value={formValues.description}
              onChange={handleChange('description')}
              error={err.description}
              width='100%'
              onEnterClick={handleNextStep}
            />
            <Button
              className={styles.btn}
              onClick={handleNextStep}
              isLoading={loading}
              type='Primary'>
              Next Step
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BusinessInfo;
